import React from "react";
import { AddFormButton, FilterButton } from "../../../../shared/components/TableElements";
import { useTranslation } from "react-i18next";
import {
  IntegrationCard,
  LogoBox,
  NameCol,
  ProviderNameText,
  ConnectedBadge,
  ConnectedDot,
  ManageButton,
} from "./SingleProvider";

const FuelCardProvider = ({ providerName, providerIcon, providerState, handleClick }) => {
  const { t } = useTranslation("common");

  const renderButton = () => {
    if (providerState === 1 || providerState === 2) {
      return <AddFormButton type="button" onClick={handleClick}>{t("connect")}</AddFormButton>;
    }
    if (providerState === 3) {
      return <ManageButton type="button" onClick={handleClick}>{t("manage")}</ManageButton>;
    }
    if (providerState === 4) {
      return <AddFormButton type="button" disabled>{t("connect")}</AddFormButton>;
    }
    if (providerState === 5) {
      return <FilterButton disabled style={{ opacity: 0.4 }}>{t("coming_soon")}</FilterButton>;
    }
    return null;
  };

  return (
    <IntegrationCard>
      <LogoBox>
        <img
          src={providerIcon}
          alt={providerName}
          style={{ objectFit: "contain", opacity: providerState === 5 ? 0.4 : 1, maxWidth: "96px", maxHeight: "52px" }}
        />
      </LogoBox>
      <NameCol>
        <ProviderNameText>{providerName}</ProviderNameText>
        {providerState === 3 && (
          <ConnectedBadge>
            <ConnectedDot />
            {t("connected")}
          </ConnectedBadge>
        )}
      </NameCol>
      <div>{renderButton()}</div>
    </IntegrationCard>
  );
};

export default FuelCardProvider;
